import React, { useEffect, useState } from 'react'
import ReactDatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";

import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { Button, Card, CardBody, Col, Label, Row } from 'reactstrap'
import BasicTable from '../../../../components/BasicTable/BasicTable'
import { ColorsPalette, ColorsPalette2, ColorsPaletteLoop } from '../../Dashboard'
// import { changePriceAlertsQueryObject, changeTestsQueryObject, clearPriceAlerts, getPriceAlerts, getTests, openAlert } from '../../../../store/actions'
// import PriceAlertsTableColumns from '../../../Offers/PriceAlerts/PriceAlertsTableColumns'
import LoopReChart from '../../LoopReChart/LoopReChart'
import TopFiltersShoppingTableColumns from '../MarketplaceAndShoppingStatsTab/TopFiltersShoppingTableColumns'
import TopSearchedPhrasesTableColumns from '../MarketplaceAndShoppingStatsTab/TopSearchedPhrasesTableColumns'
import TopCouponsDisplayedTableColumns from './TopCouponsDisplayedTableColumns'
import TopProductsClicksTableColumns from './TopProductsClicksTableColumns'
import TopProductsViewsTableColumns from './TopProductsViewsTableColumns'
import { getDisplayedCouponsStats, getFeedAnalytics, getFeedItemsAnalyticsStats, getFeedsCountsStats } from '../../../../helpers/backend_helper'
import moment from "moment-timezone";
import { demoFeedsCountsStats, demoFeedsItemsClicks, demoMostClickedFeedItems, demoMostViewedFeedItems, mostDisplayedCouponsDemoStats } from './DemoStatsData';

interface Props {
    t: (text: string) => string;
}

const MarketingStatsTab = ({ t }: Props) => {
    const history = useHistory();
    const userEmail = useSelector((state: any) => state?.Account?.user?.email)

    // const handleSetQueryObject = (customQueryObject = {}) => {
    //     getMostViewedFeedItems(1, { sort: "stats.totals.views", direction: 'desc', ...customQueryObject })
    //     getMostClickedFeedItems(1, { sort: "stats.totals.clicks", direction: 'desc', ...customQueryObject })
    // }

    useEffect(() => {
        const params = new URLSearchParams(location?.search)
        // const sort = params.get("sort")
        // const direction = params.get("direction")
        const period_from = params.get("period_from")
        const period_to = params.get("period_to")
        if(period_from && period_to){
        //   setTimeout(() => {
            setDateRange([new Date(period_from), new Date(period_to)])
        //   }, 200)
        }
    }, [])

    const setDemoStats = () => {
        setFeedsCountsStats(demoFeedsCountsStats)
        setFeedItemsClicks(demoFeedsItemsClicks)
        setMostClickedFeedItems(demoMostClickedFeedItems)
        setMostViewedFeedItems(demoMostViewedFeedItems)
        setMostDisplayedCoupons(mostDisplayedCouponsDemoStats)
    }

    useEffect(() => {
        if(userEmail === "demo@loop.com"){
            setDemoStats()
        }else{
            getMostViewedFeedItems(1, { sort: "stats.totals.views", direction: 'desc' })
            getMostClickedFeedItems(1, { sort: "stats.totals.clicks", direction: 'desc' })
            getFeedItemsClicks();
            getFeedItemsCount();
            getMostDisplayedCoupons();
        }
    }, [])

    const[feedsCountsStats, setFeedsCountsStats] = useState<any>({
        stats: []
    });
    const getFeedItemsCount = async (queryObject = {}) => {
        try {
            const params = new URLSearchParams({...(queryObject ?? {}), field: 'clicks' })

            //default from 2025-01-01 to today
            if(!(params.get("period_from") && params.get("period_to"))){
                params.set("period_from", "2025-01-01")
                params.set("period_to", moment(new Date())?.format("YYYY-MM-DD"))
            }

            const response = await getFeedsCountsStats(params?.toString())
            let formatted = { ...response };
            if(response?.type === "day"){
                formatted.stats = response?.stats?.map((stat: any) => {
                    stat.formatted_period = stat.period.from;
                    return stat;
                })
            }else if(response?.type === "week"){
                // let weekCounter = 1;
                // let prevMonth = "";
                // let currentMonth = null;
                // formatted.stats = response?.stats?.map((stat: any) => {
                //     currentMonth = moment(stat.period.to)?.format("MM")
                //     if(currentMonth !== prevMonth){
                //         weekCounter = 1;
                //     }else{
                //         weekCounter += 1;
                //     }
                //     prevMonth = moment(stat.period.to)?.format("MM")
                //     stat.formatted_period = moment(stat.period.to)?.format("YYYY-MM") + `-W${weekCounter}`
                //     return stat;
                // })
                formatted.stats = response?.stats?.map((stat: any) => {
                    let currentDay = parseInt(moment(stat.period.to)?.format("DD"));
                    let currentWeek = Math.ceil(currentDay/7)
                    // prevMonth = moment(stat.period.to)?.format("MM")
                    stat.formatted_period = moment(stat.period.to)?.format("YYYY.MM") + `.W${currentWeek}`
                    return stat;
                })
            }else if(response?.type === "month"){
                formatted.stats = response?.stats?.map((stat: any) => {
                    stat.formatted_period = moment(stat.period.from)?.format("YYYY.MM")
                    return stat;
                })
            }else if(response?.type === "year"){
                formatted.stats = response?.stats?.map((stat: any) => {
                    stat.formatted_period = moment(stat.period.from)?.format("YYYY")
                    return stat;
                })
            }

            setFeedsCountsStats(formatted)
        } catch (error) {

        }
    }
    
    const[feedItemsClicks, setFeedItemsClicks] = useState<any>({
        stats: []
    });
    const getFeedItemsClicks = async (queryObject = {}) => {
        try {
            const params = new URLSearchParams({...(queryObject ?? {}), field: 'clicks' })

            //default from 2025-01-01 to today
            if(!(params.get("period_from") && params.get("period_to"))){
                params.set("period_from", "2025-01-01")
                params.set("period_to", moment(new Date())?.format("YYYY-MM-DD"))
            }

            const response = await getFeedItemsAnalyticsStats(params?.toString())
            let formatted = { ...response };
            if(response?.type === "day"){
                formatted.stats = response?.stats?.map((stat: any) => {
                    stat.formatted_period = stat.period.from;
                    return stat;
                })
            }else if(response?.type === "week"){
                // let weekCounter = 1;
                // let prevMonth = "";
                // let currentMonth = null;
                // formatted.stats = response?.stats?.map((stat: any) => {
                //     currentMonth = moment(stat.period.to)?.format("MM")
                //     if(currentMonth !== prevMonth){
                //         weekCounter = 1;
                //     }else{
                //         weekCounter += 1;
                //     }
                //     prevMonth = moment(stat.period.to)?.format("MM")
                //     stat.formatted_period = moment(stat.period.to)?.format("YYYY-MM") + `-W${weekCounter}`
                //     return stat;
                // })
                formatted.stats = response?.stats?.map((stat: any) => {
                    let currentDay = parseInt(moment(stat.period.to)?.format("DD"));
                    let currentWeek = Math.ceil(currentDay/7)
                    // prevMonth = moment(stat.period.to)?.format("MM")
                    stat.formatted_period = moment(stat.period.to)?.format("YYYY.MM") + `.W${currentWeek}`
                    return stat;
                })
            }else if(response?.type === "month"){
                formatted.stats = response?.stats?.map((stat: any) => {
                    stat.formatted_period = moment(stat.period.from)?.format("YYYY.MM")
                    return stat;
                })
            }else if(response?.type === "year"){
                formatted.stats = response?.stats?.map((stat: any) => {
                    stat.formatted_period = moment(stat.period.from)?.format("YYYY")
                    return stat;
                })
            }

            setFeedItemsClicks(formatted)
        } catch (error) {

        }
    }
    
    const[mostViewedFeedItems, setMostViewedFeedItems] = useState<any>({
        info: {
            total_items: 0,
            current_page: 1,
            page_count: 20,
            total_pages: 1
        },
        items: []
    });
    const getMostViewedFeedItems = async (page = 1, queryObject?: any) => {
            try {
                const params = new URLSearchParams(queryObject ?? {})
                const response = await getFeedAnalytics(page, params?.toString())
                setMostViewedFeedItems(response)
            } catch (error) {
        }
    }

    const[mostClickedFeedItems, setMostClickedFeedItems] = useState<any>({
        info: {
            total_items: 0,
            current_page: 1,
            page_count: 20,
            total_pages: 1
        },
        items: []
    });
    const getMostClickedFeedItems = async (page = 1, queryObject?: any) => {
            try {
                const params = new URLSearchParams(queryObject ?? {})
                const response = await getFeedAnalytics(page, params?.toString())
                setMostClickedFeedItems(response)
            } catch (error) {
        }
    }

    const[mostDisplayedCoupons, setMostDisplayedCoupons] = useState<any>({});
    const getMostDisplayedCoupons = async (queryObject?: any) => {
            try {
                const params = new URLSearchParams(queryObject ?? {})
                const response = await getDisplayedCouponsStats(params?.toString())
                setMostDisplayedCoupons(response)
            } catch (error) {
        }
    }

    const [dateRange, setDateRange] = useState<any>([null, null]);
    const [startDate, endDate] = dateRange;
    const [allowClear, setAllowClear] = useState(false);
    const [queryObject, setQueryObject] = useState<any>({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        handleDatePicker()
      }, [startDate, endDate])

    const handleDatePicker = async () => {
        if(startDate && endDate){
            const customFilters = {
              period_from: moment(startDate).format('YYYY-MM-DD'),
              period_to: moment(endDate).format('YYYY-MM-DD')
            }
          //   customFilters.sort = customFilters.sort?.replace("totals", "period_counts")
          
            setIsLoading(true)
            await Promise.all([
                getMostViewedFeedItems(1, { sort: "stats.totals.views"?.replace("totals", "period_counts"), direction: 'desc', ...customFilters }),
                getMostClickedFeedItems(1, { sort: "stats.totals.clicks"?.replace("totals", "period_counts"), direction: 'desc', ...customFilters }),
                getFeedItemsClicks(customFilters),
                getFeedItemsCount(customFilters),
                getMostDisplayedCoupons(customFilters)
            ])
            setIsLoading(false)

            setAllowClear(true)

            const params = new URLSearchParams(location?.search)
            params.set("period_from", moment(startDate)?.format("YYYY-MM-DD"))
            params.set("period_to", moment(endDate)?.format("YYYY-MM-DD"))
            history?.replace(`${location?.pathname}?${params?.toString()}`)
      
        }else if(allowClear && startDate === null && endDate === null){
            // const customFilters = { ...queryObject }
            // delete customFilters.period_from
            // delete customFilters.period_to
            // customFilters.sort = customFilters.sort?.replace("period_counts", "totals")

            setIsLoading(true)
            await Promise.all([
                getMostViewedFeedItems(1, { sort: "stats.totals.views"?.replace("period_counts", "totals"), direction: 'desc' }),
                getMostClickedFeedItems(1, { sort: "stats.totals.clicks"?.replace("period_counts", "totals"), direction: 'desc' }),
                getFeedItemsClicks(),
                getFeedItemsCount(),
                getMostDisplayedCoupons()
            ])
            setIsLoading(false)

            const params = new URLSearchParams(location?.search)
            params.delete("period_from")
            params.delete("period_to")
            history?.replace(`${location?.pathname}?${params?.toString()}`)
        }
    }

    return (
        <div className="add-to-stats-tab">

            <div className="w-25 mb-3">
                <Label>Select period</Label>
                <ReactDatePicker
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                        setDateRange(update);
                    }}
                    className="form-control"
                    calendarClassName="react-datepicker"
                    dateFormat="dd-MM-yyyy"
                    maxDate={new Date()}
                    shouldCloseOnSelect={startDate && !endDate}
                    isClearable={true}
                    placeholderText={t("Pick a date range")}
                />
                {startDate && endDate ? (
                    <span className="text-muted text-nowrap">
                    <div>
                        Stats - {moment(startDate)?.format("YYYY-MM-DD") !== moment(endDate)?.format("YYYY-MM-DD") ? `SELECTED PERIOD` : `SELECTED DATE`}
                    </div>
                    {/* <div>
                        Gains - {queryObject?.period_from !== queryObject?.period_to 
                            ? `compares ${moment(queryObject?.period_from)?.format("DD-MM-YYYY")} with ${moment(queryObject?.period_to)?.format("DD-MM-YYYY")}`
                            : `compares selected date with the day before ${moment(queryObject?.period_from)?.subtract('1', 'days')?.format("DD-MM-YYYY")}`}
                    </div> */}
                    </span>
                ) : (
                    <span className="text-muted text-nowrap">
                        <div>Stats - TOTAL</div>
                        {/* <div>Gains - {`Compares today's date with yesterday's (${moment(new Date())?.subtract('1', 'days')?.format("DD-MM-YYYY")}).`}</div> */}
                    </span>
                )}
            </div>

            {/* ROW 1 */}
            <Row>
                <Col sm={12} md={12} lg={12} xl={6}>
                    <Card>
                        <CardBody className="p-3">
                            <h4 className="card-title" style={{marginTop: 15, marginBottom: 16}}>
                                {t("Number of products from google & FB feeds")} {feedsCountsStats?.type === "day" ? "DAI" : feedsCountsStats?.type?.toUpperCase()}LY
                                <small className='ms-1 text-muted fw-normal'>
                                    {startDate && endDate
                                        ? (
                                            moment(startDate)?.format("DD-MM-YYYY") === moment(endDate)?.format("DD-MM-YYYY") 
                                                ? `(${moment(startDate)?.format("DD-MM-YYYY")})`
                                                : `(${moment(startDate)?.format("DD-MM-YYYY")} - ${moment(endDate)?.format("DD-MM-YYYY")})`
                                        ): "(IN TOTAL)"
                                    }
                                </small>
                            </h4>
                            <LoopReChart
                                height={300}
                                data={feedsCountsStats?.stats}
                                showLoaderOnEmptyData={true}
                                xAxisDataKey="formatted_period"
                                dataMaxKey="value"
                                tooltipFormatter={(label, payload) => {
                                    // console.log(label, payload)
                                    if(feedsCountsStats?.type === "week"){
                                        const statData = payload?.[0]?.payload;
                                        return label + ` (${statData?.period?.from?.replaceAll("-", ".")}-${statData?.period?.to?.replaceAll("-", ".")})`
                                    }else{
                                        return label
                                    }
                                }}
                                lines={[
                                    // { type: "monotone", dataKey: "new", name: "New", stroke: "#4d9de0", activeDotSize: 5 },
                                    { type: "linear", dataKey: "value", name: "Number of products", stroke: ColorsPaletteLoop.green, activeDotSize: 5, label: { dataKey: "value" } },
                                    // { type: "monotone", dataKey: "total", name: "Total", stroke: "#e15554", activeDotSize: 8 },
                                ]}
                            />
                        </CardBody>
                    </Card>
                </Col>
                <Col sm={12} md={12} lg={12} xl={6}>
                    <Card>
                        <CardBody className="p-3">
                            <h4 className="card-title" style={{marginTop: 15, marginBottom: 16}}>
                                {t("Product feed clicks")} {feedItemsClicks?.type === "day" ? "DAI" : feedItemsClicks?.type?.toUpperCase()}LY
                                <small className='ms-1 text-muted fw-normal'>
                                    {startDate && endDate
                                        ? (
                                            moment(startDate)?.format("DD-MM-YYYY") === moment(endDate)?.format("DD-MM-YYYY") 
                                                ? `(${moment(startDate)?.format("DD-MM-YYYY")})`
                                                : `(${moment(startDate)?.format("DD-MM-YYYY")} - ${moment(endDate)?.format("DD-MM-YYYY")})`
                                        ): `(IN TOTAL)`
                                    }
                                </small>
                            </h4>
                            <LoopReChart
                                height={300}
                                data={feedItemsClicks?.stats}
                                showLoaderOnEmptyData={true}
                                xAxisDataKey="formatted_period"
                                dataMaxKey="value"
                                tooltipFormatter={(label, payload) => {
                                    // console.log(label, payload)
                                    if(feedItemsClicks?.type === "week"){
                                        const statData = payload?.[0]?.payload;
                                        return label + ` (${statData?.period?.from?.replaceAll("-", ".")}-${statData?.period?.to?.replaceAll("-", ".")})`
                                    }else{
                                        return label
                                    }
                                }}
                                lines={[
                                    // { type: "monotone", dataKey: "new", name: "New", stroke: "#4d9de0", activeDotSize: 5 },
                                    { type: "linear", dataKey: "value", name: "Clicks", stroke: ColorsPaletteLoop.green, activeDotSize: 5, label: { dataKey: "value" } },
                                    // { type: "monotone", dataKey: "total", name: "Total", stroke: "#e15554", activeDotSize: 8 },
                                ]}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* ROW 2 */}
            <Row>
                <Col sm={12} md={12} lg={12} xl={6}>
                    <Card style={{ height: 666, overflowY: "scroll" }}>
                        <CardBody className="p-3">
                            <div className="d-flex justify-content-between align-items-center mb-0">
                                <h4 className="card-title" style={{marginTop: 15, marginBottom: 16}}>
                                    {t("Most viewed product")}
                                    <small className='ms-1 text-muted fw-normal'>
                                        {startDate && endDate
                                            ? (
                                                moment(startDate)?.format("DD-MM-YYYY") === moment(endDate)?.format("DD-MM-YYYY") 
                                                    ? `(${moment(startDate)?.format("DD-MM-YYYY")})`
                                                    : `(${moment(startDate)?.format("DD-MM-YYYY")} - ${moment(endDate)?.format("DD-MM-YYYY")})`
                                            ): "(IN TOTAL)"
                                        }
                                    </small>
                                </h4>
                                <div className="d-flex gap-2 align-items-center">
                                    {/* <span>Date:</span>
                                    <div style={{ width: 100 }}>
                                        <ReactDatePicker
                                            selected={wishlistDateFilter}
                                            onChange={(date: any) => setWishlistDateFilter(new Date(date))}
                                            className="form-control input-small clickable"
                                            showTimeSelect={false}
                                            calendarClassName="react-datepicker"
                                            dateFormat="dd.MM.yyyy"
                                            maxDate={new Date()}
                                        />
                                    </div> */}
                                    <Button size="sm"
                                        color="dark"
                                        onClick={() => {
                                            if(startDate && endDate){
                                                history?.push(`/feed/analytics?page=1&sort=stats.totals.views&direction=desc&period_from=${
                                                    moment(startDate)?.format("YYYY-MM-DD")
                                                }&period_to=${
                                                    moment(endDate)?.format("YYYY-MM-DD")
                                                }`)
                                            }else{
                                                history?.push("/feed/analytics?page=1&sort=stats.totals.views&direction=desc")
                                            }
                                        }}
                                    >
                                        <span>Show More</span>
                                        <i className="fas fa-list ms-1" />
                                    </Button>
                                </div>
                            </div>
                            <BasicTable
                                items={mostViewedFeedItems?.items}
                                columns={TopProductsViewsTableColumns(
                                    (mostViewedFeedItems?.info?.current_page - 1) * mostViewedFeedItems?.info?.page_count,
                                    (text: string) => text,
                                    {},
                                    () => {},
                                    {},
                                    mostViewedFeedItems?.items?.[0]?.stats?.[startDate && endDate ? "period_counts" : "totals"]?.views,
                                    startDate && endDate
                                )}
                                searchbar={false}
                                // getAction={({ page }: any) => getPriceAlerts({ page, queryObject: {...queryObject, per_page: 10} })}
                                totalSize={mostViewedFeedItems?.info?.total_items}
                                sizePerPage={mostViewedFeedItems?.info?.page_count}
                                // defaultSort={{}}
                                //@ts-ignore
                                currentPage={mostViewedFeedItems?.info?.current_page}
                                tableCustomClassName="table-small"
                                simple={true}
                                isLoading={isLoading}
                            />
                        </CardBody>
                    </Card>
                </Col>
                <Col sm={12} md={12} lg={12} xl={6}>
                    <Card style={{ height: 666, overflowY: "scroll" }}>
                        <CardBody className="p-3">
                            <div className="d-flex justify-content-between align-items-center mb-0">
                                <h4 className="card-title" style={{marginTop: 15, marginBottom: 16}}>
                                    {t("Most clicked product")}
                                    <small className='ms-1 text-muted fw-normal'>
                                        {startDate && endDate
                                            ? (
                                                moment(startDate)?.format("DD-MM-YYYY") === moment(endDate)?.format("DD-MM-YYYY") 
                                                    ? `(${moment(startDate)?.format("DD-MM-YYYY")})`
                                                    : `(${moment(startDate)?.format("DD-MM-YYYY")} - ${moment(endDate)?.format("DD-MM-YYYY")})`
                                            ): "(IN TOTAL)"
                                        }
                                    </small>
                                </h4>
                                <div className="d-flex gap-2 align-items-center">
                                    {/* <span>Date:</span>
                                    <div style={{ width: 100 }}>
                                        <ReactDatePicker
                                            selected={priceAlertDateFilter}
                                            onChange={(date: any) => setPriceAlertDateFilter(new Date(date))}
                                            className="form-control input-small clickable"
                                            showTimeSelect={false}
                                            calendarClassName="react-datepicker"
                                            dateFormat="dd.MM.yyyy"
                                            maxDate={new Date()}
                                        />
                                    </div> */}
                                    <Button size="sm"
                                        color="dark"
                                        onClick={() => {
                                            if(startDate && endDate){
                                                history?.push(`/feed/analytics?page=1&sort=stats.totals.clicks&direction=desc&period_from=${
                                                    moment(startDate)?.format("YYYY-MM-DD")
                                                }&period_to=${
                                                    moment(endDate)?.format("YYYY-MM-DD")
                                                }`)
                                            }else{
                                                history?.push("/feed/analytics?page=1&sort=stats.totals.clicks&direction=desc")
                                            }
                                        }}
                                    >
                                        <span>Show More</span>
                                        <i className="fas fa-list ms-1" />
                                    </Button>
                                </div>
                            </div>
                            <BasicTable
                                items={mostClickedFeedItems?.items}
                                columns={TopProductsClicksTableColumns(
                                    (mostClickedFeedItems?.info?.current_page - 1) * mostClickedFeedItems?.info?.page_count,
                                    (text: string) => text,
                                    {},
                                    () => {},
                                    {},
                                    mostClickedFeedItems?.items?.[0]?.stats?.[startDate && endDate ? "period_counts" : "totals"]?.clicks,
                                    startDate && endDate
                                )}
                                searchbar={false}
                                // getAction={({ page }: any) => getPriceAlerts({ page, queryObject: {...queryObject, per_page: 10} })}
                                totalSize={mostClickedFeedItems?.info?.total_items}
                                sizePerPage={mostClickedFeedItems?.info?.page_count}
                                // defaultSort={{}}
                                //@ts-ignore
                                currentPage={mostClickedFeedItems?.info?.current_page}
                                tableCustomClassName="table-small"
                                simple={true}
                                isLoading={isLoading}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* ROW 3 */}
            <Row>
                <Col sm={12} md={12} lg={12} xl={6}>
                    <Card>
                        <CardBody className="p-3">
                            <div className="d-flex justify-content-between align-items-center mb-0">
                                <h4 className="card-title" style={{marginTop: 15, marginBottom: 16}}>
                                    {t("Number of coupons displayed")}
                                    <small className='ms-1 text-muted fw-normal'>
                                        {startDate && endDate
                                            ? (
                                                moment(startDate)?.format("DD-MM-YYYY") === moment(endDate)?.format("DD-MM-YYYY") 
                                                    ? `(${moment(startDate)?.format("DD-MM-YYYY")})`
                                                    : `(${moment(startDate)?.format("DD-MM-YYYY")} - ${moment(endDate)?.format("DD-MM-YYYY")})`
                                            ): "(IN TOTAL)"
                                        }
                                    </small>
                                </h4>
                                {/* <div className="d-flex gap-2 align-items-center">
                                    <span>Date:</span>
                                    <div style={{ width: 100 }}>
                                        <ReactDatePicker
                                            selected={searchedPhrasesDateFilter}
                                            onChange={(date: any) => setSearchedPhrasesDateFilter(new Date(date))}
                                            className="form-control input-small clickable"
                                            showTimeSelect={false}
                                            calendarClassName="react-datepicker"
                                            dateFormat="dd.MM.yyyy"
                                            maxDate={new Date()}
                                        />
                                    </div>
                                    <Button size="sm" color="dark">
                                        <span>Show More</span>
                                        <i className="fas fa-list ms-1" />
                                    </Button>
                                </div> */}
                            </div>
                            <BasicTable
                                items={mostDisplayedCoupons?.stats}
                                columns={TopCouponsDisplayedTableColumns(
                                    0,
                                    (text: string) => text,
                                    {},
                                    () => {},
                                    {},
                                    mostDisplayedCoupons?.stats?.[0]?.displayed_count
                                )}
                                searchbar={false}
                                // getAction={({ page }: any) => getPriceAlerts({ page, queryObject: {...queryObject, per_page: 10} })}
                                totalSize={mostDisplayedCoupons?.stats?.length}
                                sizePerPage={mostDisplayedCoupons?.stats?.length}
                                // defaultSort={{}}
                                //@ts-ignore
                                currentPage={1}
                                tableCustomClassName="table-small"
                                simple={true}
                                isLoading={isLoading}
                            />
                        </CardBody>
                    </Card>
                </Col>
                <Col sm={12} md={12} lg={12} xl={6}>
                </Col>
            </Row>

        </div>
    )
}

export default MarketingStatsTab


